export default {
	type: 'object',
	properties: {
		planId: { type: 'string' },
		dropEventId: { type: 'string' },
		subscriptionInfo: { type: 'string' },
	},
	required: ['planId', 'dropEventId'],
	additionalProperties: false,
}
